export default "__VITE_ASSET__CL77kWgi__"